import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "grandjs-cli"
    }}>{`Grandjs Cli`}</h1>
    <p>{`A Grandjs Cli to ease the playing with grandjs!`}</p>
    <h2 {...{
      "id": "installing"
    }}>{`Installing`}</h2>
    <p>{`you need to install this package globally`}</p>
    <pre><code parentName="pre" {...{}}>{`npm i -g grand-cli
`}</code></pre>
    <h2 {...{
      "id": "initialize-new-project"
    }}>{`Initialize new project`}</h2>
    <p>{`just run the following command:`}</p>
    <pre><code parentName="pre" {...{}}>{`grand-cli init appName
`}</code></pre>
    <h2 {...{
      "id": "run-dev"
    }}>{`Run dev`}</h2>
    <p>{`run the app in development mode`}</p>
    <pre><code parentName="pre" {...{}}>{`grand-cli dev
`}</code></pre>
    <h2 {...{
      "id": "build-the-app-for-production"
    }}>{`Build the app for production`}</h2>
    <pre><code parentName="pre" {...{}}>{`grand-cli build
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      